<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
    rounded
  >
    <template #activator="{on, attrs}">
      <v-btn
        icon
        class="user-icon"
        v-bind="attrs"
        v-on="on"
      >{{userInitials}}</v-btn>
    </template>

    <v-sheet class="user-info text-center pa-4">
      <div class="mb-2">
        <strong class="font-weight-500">{{user.accountName}}</strong><br>
        <small v-if="user.isAccountOwner"><i>{{user.userEmail}}</i></small>
        <v-alert v-else dense outlined class="text--primay-text px-1 py-1 my-2">
          <small>Eingeloggt mit:</small><br>
          <strong class="font-weight-500">{{user.userName}}</strong><br>
          <small><i>{{user.userEmail}}</i></small>
        </v-alert>
      </div>
      <div>
        <v-btn
          :href="accountUrl"
          class="my-2"
          target="_blank"
          color="accent"
          rounded
          depressed
        >
          Konto verwalten
        </v-btn><br>
        <v-btn text x-small href="/select-account">Konto wechseln</v-btn><br>
        <v-btn text x-small href="/logout">Ausloggen</v-btn>
      </div>
    </v-sheet>
  </v-menu>
</template>

<script>
  import {participantInitials, accountUrl} from '../assets/js/utils';

  export default {
    name: 'UserInfo',

    data: () => ({
      accountUrl
    }),

    computed: {
      user() {
        return this.$store.getters['session/getUser'];
      },

      userInitials() {
        return participantInitials(this.user?.accountName);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .user-icon {
    font-weight: normal;
    color: #fff !important;
    background-color: $primary-light;

    &.v-btn.v-btn--disabled {
      color: #fff !important;
    }
  }

  .user-info {
    .v-alert {
      line-height: 1.5;
      border: none !important;
      background-color: $background-color !important;
    }
  }
</style>
